import { render, staticRenderFns } from "./CompleteBuyPointPayPal.vue?vue&type=template&id=4115629a&scoped=true&"
import script from "./CompleteBuyPointPayPal.vue?vue&type=script&lang=js&"
export * from "./CompleteBuyPointPayPal.vue?vue&type=script&lang=js&"
import style0 from "./CompleteBuyPointPayPal.vue?vue&type=style&index=0&id=4115629a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4115629a",
  null
  
)

export default component.exports